(function(factory) {
  if (typeof jQuery === 'undefined') {
    document.addEventListener('DOMContentLoaded', function() {
      if (typeof jQuery === 'undefined') {
        console.error('jQuery is required but not loaded');
        return;
      }
      factory(jQuery);
    });
  } else {
    factory(jQuery);
  }
}(function($) { 

  // 将整个 loadSearchResults 函数用防抖包装
  const debouncedLoadSearchResults = $.debounce(async function(query, page = 1) {
    // 再次检查查询长度，以防在延迟期间内容被清空
    if (isLoading || !query || query.length < 2) {
      $predictive_results.removeClass('active');
      $predictive_items.empty();
      return;
    }
    isLoading = true;

    try {
      // 使用一个请求获取建议词
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=query&resources[limit]=10`
      );
      const data = await response.json();

      let html = '';

      // 处理搜索建议词
      if (data.resources.results.queries && data.resources.results.queries.length > 0) {
        html += '<div class="predictive-search-suggestions">';

        // 为每个搜索建议获取产品数量
        const suggestionCounts = await Promise.all(
          data.resources.results.queries.map(async (suggestion) => {
            try {
              // 使用一个简单的方法：直接请求搜索页面并从HTML中提取数量
              const response = await fetch(`/search?q=${encodeURIComponent(suggestion.text)}&type=product`);
              const html = await response.text();
              
              // 尝试从HTML中提取产品数量
              let count = 0;
              
              // 创建一个临时的DOM元素来解析HTML
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // 首先尝试从页面标题中获取产品数量
              const titleElement = doc.querySelector('title');
              if (titleElement) {
                const titleText = titleElement.textContent.trim();
                
                // 尝试匹配不同格式的标题中的数字
                let titleMatch;
                
                // 匹配 "Search: X results found for" 格式
                titleMatch = titleText.match(/Search:\s*(\d+)\s*results found for/i);
                if (!titleMatch) {
                  // 匹配 "X products" 格式
                  titleMatch = titleText.match(/(\d+)\s+products?/i);
                }
                if (!titleMatch) {
                  // 匹配任何数字后跟 results
                  titleMatch = titleText.match(/(\d+)\s+results/i);
                }
                
                if (titleMatch && titleMatch[1]) {
                  count = parseInt(titleMatch[1], 10);
                }
              }
              
              // 如果从标题中没有获取到数量，尝试其他方法
              if (count === 0) {
                // 尝试查找包含产品总数量的元素
                const paginateElement = doc.querySelector('.page-item.active .page-text');
                if (paginateElement) {
                  // 尝试多种可能的文本格式来提取数字
                  const textContent = paginateElement.textContent.trim();
                  let match;
                  
                  // 尝试匹配 "A total of X products" 格式
                  match = textContent.match(/total of (\d+)/i);
                  if (!match) {
                    // 尝试匹配任何数字
                    match = textContent.match(/(\d+)/);
                  }
                  
                  if (match && match[1]) {
                    count = parseInt(match[1], 10);
                  }
                }
              }
              
              // 如果上面的方法都没有找到数量，尝试计算产品元素
              if (count === 0) {
                // 尝试查找产品网格中的产品数量
                const productElements = doc.querySelectorAll('.product-grid .grid__item, .collection .grid__item, .grid__item.product-item');
                if (productElements.length > 0) {
                  count = productElements.length;
                  console.log('Count from product elements:', count);
                  
                  // 尝试查找分页器，看是否有多页
                  const paginationItems = doc.querySelectorAll('.pagination__item, .page-item');
                  if (paginationItems.length > 0) {
                    // 如果有分页，尝试从最后一个分页项获取总页数
                    const lastPageItem = Array.from(paginationItems)
                      .filter(item => !item.classList.contains('pagination__item--next') && !item.classList.contains('next'))
                      .pop();
                    
                    if (lastPageItem) {
                      const pageNumber = parseInt(lastPageItem.textContent.trim(), 10);
                      if (!isNaN(pageNumber) && pageNumber > 1) {
                        // 估算总产品数 (当前页产品数 * 总页数)
                        count = count * pageNumber;
                        console.log('Estimated total count (products * pages):', count);
                      }
                    }
                  }
                }
              }
              
              return {
                text: suggestion.text,
                count: count
              };
            } catch (error) {
              console.error('Error fetching count for suggestion:', error);
              return {
                text: suggestion.text,
                count: 0
              };
            }
          })
        );

        // 按产品数量排序并限制数量
        const sortedSuggestions = suggestionCounts
          .sort((a, b) => b.count - a.count)  // 按数量从高到低排序
          .slice(0, 10);  // 只取前10个

        // 渲染搜索建议
        sortedSuggestions.forEach(suggestion => {
          const highlightedText = highlightSearchTerm(suggestion.text, query);
          html += `
            <a href="/search?q=${encodeURIComponent(
              suggestion.text
            )}&type=product" class="predictive-search-suggestion-item">
              <span class="suggestion-text" data-query="${suggestion.text}">${highlightedText}</span>
              <span class="result-count"><span>${suggestion.count}</span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.0013 2.66663L7.0613 3.60663L10.7813 7.33329H2.66797V8.66663H10.7813L7.0613 12.3933L8.0013 13.3333L13.3346 7.99996L8.0013 2.66663Z" fill="#6A51B7"/></svg></span>
            </a>
          `;
        });

        html += '</div>';
        $predictive_items.html(html);
        $predictive_results.addClass('active');
      } else {
        $predictive_items.empty();
        $predictive_results.removeClass('active');
      }
    } catch (error) {
      console.error('Error:', error);
      $predictive_items.empty();
      $predictive_results.removeClass('active');
    } finally {
      isLoading = false;
    }
  }, 300);

  // 头部搜索用户体验增强
  var $search_form = $('form.search');
  if ($search_form.length) {
    var $input = $search_form.children('[name=q]'),
      $clear_input = $input.siblings('input~svg'),
      $predictive_results = $('.predictive-search-results'),
      $predictive_items = $('.predictive-search-items'),
      $search_history = $('.search-history'),
      $search_bar = $('.search-bar'),
      $confirm_dialog = $('.confirm-dialog'),
      currentPage = 1,
      isLoading = false,
      hasMore = true,
      currentQuery = '',
      productsPerPage = 6;
      MAX_HISTORY = 5;

    // 先定义 searchHistory 对象
    const searchHistory = {
      key: 'search_history',

      // 获取历史记录
      get: function () {
        try {
          return JSON.parse(localStorage.getItem(this.key)) || [];
        } catch (e) {
          return [];
        }
      },

      // 添加记录
      add: function (query) {
        if (!query) return;
        let history = this.get();
        // 删除重复项
        history = history.filter((item) => item.text !== query);
        // 添加新记录到开头
        history.unshift({
          text: query,
          time: new Date().toISOString(),
        });
        // 限制数量
        if (history.length > MAX_HISTORY) {
          history = history.slice(0, MAX_HISTORY);
        }
        localStorage.setItem(this.key, JSON.stringify(history));
      },

      // 删除记录
      remove: function (query) {
        let history = this.get();
        history = history.filter((item) => item.text !== query);
        localStorage.setItem(this.key, JSON.stringify(history));
      },

      // 显示历史记录
      show: function () {
        const history = this.get();
        if (history.length === 0) {
          $search_history.hide();
          return;
        }

        let html =
          '<div class="search-history-header">' +
          '<h2 class="search-content-title search-history-title"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.9987 0.333374C3.33203 0.333374 0.332031 3.33337 0.332031 7.00004C0.332031 10.6667 3.33203 13.6667 6.9987 13.6667C10.6654 13.6667 13.6654 10.6667 13.6654 7.00004C13.6654 3.33337 10.6654 0.333374 6.9987 0.333374ZM6.9987 12.3334C4.0587 12.3334 1.66536 9.94004 1.66536 7.00004C1.66536 4.06004 4.0587 1.66671 6.9987 1.66671C9.9387 1.66671 12.332 4.06004 12.332 7.00004C12.332 9.94004 9.9387 12.3334 6.9987 12.3334ZM7.33203 3.66671H6.33203V7.66671L9.7987 9.80004L10.332 8.93337L7.33203 7.13337V3.66671Z" fill="#404040"/></svg><span>Search History</span></h2>' +
          '<button class="clear-all-history">' +
          '<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44546 15.4814C1.44546 16.5 2.27879 17.3333 3.29731 17.3333H10.7047C11.7232 17.3333 12.5566 16.5 12.5566 15.4814V4.37033H1.44546V15.4814ZM3.29731 6.22218H10.7047V15.4814H3.29731V6.22218ZM10.2418 1.59255L9.31583 0.666626H4.6862L3.76027 1.59255H0.519531V3.4444H13.4825V1.59255H10.2418Z" fill="#868686"/></svg>' +
          '</button>' +
          '</div>' +
          '<div class="search-content-items-box search-history-items">';
        history.forEach((item) => {
          // 限制搜索词长度为20个字符
          const displayText = item.text.length > 20 ? item.text.substring(0, 20) + '...' : item.text;

          // 删除单个历史记录
          // html += `
          //   <div class="search-content-item search-history-item">
          //     <span class="history-text" title="${item.text}">${displayText}</span>
          //     <button class="remove-history" data-query="${item.text}">
          //       <svg viewBox="0 0 12 12">
          //         <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="2"/>
          //       </svg>
          //     </button>
          //   </div>
          // `;
          html += `
          <div class="search-content-item search-history-item">
            <span class="history-text" title="${item.text}">${displayText}</span>
          </div>
          `;
        });

        html += '</div>';

        $search_history.html(html).show();
      },

      // 清空所有历史记录的方法
      clearAll: function () {
        localStorage.removeItem(this.key);
        this.show();
      },
    };

    // 初始化显示搜索历史
    searchHistory.show();

    // 添加点击外部关闭搜索框 (仅PC端)
    $(document).on('click', function(e) {
      if (window.innerWidth > 1366) {
        // 如果点击的不是搜索框内部元素且不是搜索按钮
        if (!$(e.target).closest($search_bar).length && 
          !$(e.target).closest('.but-search').length && 
          !$(e.target).closest('.confirm-dialog').length) {
          $search_bar.removeClass('active');
        }
      }
    });

    // 点击搜索栏区域时隐藏预测搜索结果
    $search_bar.on('click', function () {
      if ($predictive_results.hasClass('active')) {
        $predictive_results.removeClass('active');
      }
    });

    // 防止搜索框内部点击事件冒泡
    $search_bar.on('click', function(e) {
      e.stopPropagation();
    });

    // 阻止搜索框的点击事件冒泡
    $input.on('click', function (e) {
      e.stopPropagation();
    });

    // 阻止预测搜索结果的点击事件冒泡
    $predictive_results.on('click', function (e) {
      e.stopPropagation();
    });

    // 在这里添加热搜词点击事件处理
    $('.hot-search').on('click', '.hot-search-item', function () {
      const hotText = $(this).find('.hot-text').text().trim();
      // 移除表情符号等特殊字符,只保留文字内容
      const cleanText = hotText.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27FF]|[\uE000-\uF8FF]/g, '').trim();
      
      // 添加到搜索历史
      searchHistory.add(cleanText);

      // 使用表单的 action 属性获取搜索URL
      const searchUrl = $search_form.attr('action');

      // 跳转到搜索结果页面
      window.location.href = `${searchUrl}?q=${encodeURIComponent(
        cleanText
      )}&type=product&options[prefix]=last`;
    });

    // 事件绑定
    $search_history.on('click', '.search-history-item .history-text', function () {
      const query = $(this).text();
      // 使用表单的 action 属性获取搜索URL
      const searchUrl = $search_form.attr('action');
      
      // 更新这条记录到最前面
      searchHistory.add(query);
      
      // 直接跳转到搜索结果页面
      window.location.href = `${searchUrl}?q=${encodeURIComponent(
        query
      )}&type=product&options[prefix]=last`;
    });

    // 删除单个历史记录
    // $search_history.on('click', '.remove-history', function (e) {
    //   e.stopPropagation();
    //   const query = $(this).data('query');
    //   searchHistory.remove(query);
    //   searchHistory.show();
    // });

    // 添加删除所有历史记录的事件监听
    $search_history.on('click', '.clear-all-history', function (e) {
      e.stopPropagation();
      showConfirmDialog(() => {
        searchHistory.clearAll();
      });
    });

    // 输入框处理
    $input.on('input', function() {
      const query = $(this).val().trim();
      $clear_input.toggle(!!query);

      // 如果输入少于2个字符，直接移除active类
      if (query.length < 2) {
        $predictive_results.removeClass('active');
      }

      if (query !== currentQuery) {
        currentPage = 1;
        hasMore = true;
        currentQuery = query;
        debouncedLoadSearchResults(query);
      }
    });

    // 表单提交时保存搜索记录
    $search_form.on('submit', function (e) {
      e.preventDefault();
      const searchQuery = $input.val() || defaultSearch;
      if (searchQuery) {
        // 添加到搜索历史
        searchHistory.add(searchQuery);
        // 延迟清空输入框
        setTimeout(() => {
          $input.val('');
          $clear_input.hide();
        }, 100);
      }
      // 跳转到搜索结果页面
      window.location.href = `${this.action}?q=${encodeURIComponent(
        searchQuery
      )}&type=product&options[prefix]=last`;
    });

    // 修改清除按钮点击事件
    $clear_input.on('click', function () {
      $input.val('').focus(); // 清空输入框并保持焦点
      $(this).hide(); // 隐藏清除按钮
      $predictive_results.removeClass('active'); // 隐藏预测搜索结果
      $predictive_items.empty(); // 清空预测搜索结果内容
      currentQuery = ''; // 重置当前查询
    });

    // 历史记录相关事件
    $predictive_items.on('click', '.search-history-item .history-text', function () {
      const query = $(this).text();
      $input.val(query).trigger('input');
    });

    // 删除单个历史记录
    // $predictive_items.on('click', '.remove-history', function (e) {
    //   e.stopPropagation();
    //   const query = $(this).data('query');
    //   searchHistory.remove(query);
    //   searchHistory.show();
    // });

    $predictive_items.on('click', '.clear-history', function () {
      searchHistory.clear();
      searchHistory.show();
    });

    // 添加高亮搜索词的函数
    function highlightSearchTerm(text, searchTerm) {
      if (!searchTerm) return text;
      // 将搜索词按空格分割，并按长度从长到短排序
      const terms = searchTerm.split(/\s+/)
        .filter(term => term.length > 0)
        .sort((a, b) => b.length - a.length);
        
      let result = text;
      terms.forEach(term => {
        const regex = new RegExp(`(${escapeRegExp(term)})`, 'gi');
        result = result.replace(regex, '<span class="highlight">$1</span>');
      });
      return result;
    }

    // 添加关联词点击事件处理
    $predictive_items.on('click', '.predictive-search-suggestion-item', function(e) {
      e.preventDefault();
      const query = $(this).find('.suggestion-text').data('query');
      
      // 添加到搜索历史
      searchHistory.add(query);
      
      // 跳转到搜索结果页面
      window.location.href = `/search?q=${encodeURIComponent(
        query
      )}&type=product&options[prefix]=last`;
    });

    // 添加转义正则表达式特殊字符的函数
    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    // 格式化价格的辅助函数
    function formatPrice(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(cents / 100);
    }

    // 添加蒙版元素
    $('body').append('<div class="search-overlay"></div>');
    const $searchOverlay = $('.search-overlay');
    const $butSearch = $('.but-search');
    const $footerDecor = $(".footer-decor");

    // 定义 searchIcon 和 closeIcon图标
    const searchIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="svg" src="//hiccpet.com/cdn/shop/t/8/assets/search.svg?v=170443734266537322501735195135" alt="">
      <path d="M15.7539 14.255H14.9639L14.6839 13.985C15.6639 12.845 16.2539 11.365 16.2539 9.755C16.2539 6.165 13.3439 3.255 9.75391 3.255C6.16391 3.255 3.25391 6.165 3.25391 9.755C3.25391 13.345 6.16391 16.255 9.75391 16.255C11.3639 16.255 12.8439 15.665 13.9839 14.685L14.2539 14.965V15.755L19.2539 20.745L20.7439 19.255L15.7539 14.255ZM9.75391 14.255C7.26391 14.255 5.25391 12.245 5.25391 9.755C5.25391 7.26501 7.26391 5.255 9.75391 5.255C12.2439 5.255 14.2539 7.26501 14.2539 9.755C14.2539 12.245 12.2439 14.255 9.75391 14.255Z" fill="currentColor"></path>
    </svg>`;
    const closeIcon = `<svg width="24" height="24" viewBox="0 0 384 512">
      <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
    </svg>`;

    // 修改 preventScroll 函数，更好地处理移动端触摸滚动
    const preventScroll = function(e) {
      // 如果搜索栏不是激活状态，不需要处理
      if (!$('.search-bar').hasClass('active')) {
        return;
      }
      
      const $target = $(e.target);
      const $searchBar = $('.search-bar');
      
      // 如果目标元素不在 search-bar 内，直接阻止所有滚动/触摸事件
      // 但只在事件可取消时才尝试取消
      if (!$target.closest('.search-bar').length) {
        if (e.cancelable) {
          e.preventDefault();
          e.stopPropagation();
        }
        return false;
      }

      // 处理 search-bar 内的滚动
      const searchBar = $searchBar[0];
      const scrollTop = searchBar.scrollTop;
      const scrollHeight = searchBar.scrollHeight;
      const clientHeight = searchBar.clientHeight;
      
      // 在顶部或底部时阻止继续滚动
      // 但只在事件可取消时才尝试取消
      if (
        (scrollTop <= 0 && (
          (e.deltaY !== undefined && e.deltaY < 0) || 
          (e.touches && e.targetTouches && e.touches[0] && e.targetTouches[0] && e.touches[0].clientY > e.targetTouches[0].clientY)
        )) || // 在顶部继续向上滚动
        (scrollTop + clientHeight >= scrollHeight - 1 && (
          (e.deltaY !== undefined && e.deltaY > 0) || 
          (e.touches && e.targetTouches && e.touches[0] && e.targetTouches[0] && e.touches[0].clientY < e.targetTouches[0].clientY)
        )) // 在底部继续向下滚动
      ) {
        if (e.cancelable) {
          e.preventDefault();
          e.stopPropagation();
        }
        return false;
      }
    };

    // 设置search-bar状态的函数
    function setSearchBarHeight() {
      const hasActiveClass = $search_bar.hasClass('active');
      const headerHeight = $('header').outerHeight(); // 保留这个，PC端需要用
      const isAnnouncementHidden = $('.announcement-bar-section').hasClass('ouryincang');    
      
      // 切换搜索按钮图标
      $('.but-search').html(hasActiveClass ? closeIcon : searchIcon);
      
      if (window.innerWidth <= 1366) {
        if (hasActiveClass) {
          // 移动端搜索栏设置为全屏显示
          $search_bar.css({
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'right': '0',
            'max-height': '100vh',
            'overflow-y': 'auto',
            '-webkit-overflow-scrolling': 'touch',
            'z-index': '201'
          });

          // 禁用外部滚动 - 添加更多的触摸事件监听
          // 移除之前的事件监听器，防止重复添加
          document.removeEventListener('wheel', preventScroll, { passive: false });
          document.removeEventListener('touchmove', preventScroll, { passive: false });
          document.removeEventListener('touchstart', preventScroll, { passive: false });
          document.removeEventListener('touchend', preventScroll, { passive: false });
          document.removeEventListener('touchcancel', preventScroll, { passive: false });
          
          // 重新添加事件监听器
          document.addEventListener('wheel', preventScroll, { passive: false });
          document.addEventListener('touchmove', preventScroll, { passive: false });
          document.addEventListener('touchstart', preventScroll, { passive: false });
          document.addEventListener('touchend', preventScroll, { passive: false });
          document.addEventListener('touchcancel', preventScroll, { passive: false });
          
          // 给 body 添加类
          $('body').addClass('search-active');
          
          // 显示蒙版
          $searchOverlay.css({
            "top": "0",
            "opacity": 1,
            "visibility": "visible",
            "z-index": "200"
          });
          
          // search-bar 激活时, 禁用 footer-decor
          $footerDecor.css({
            "display": "none"
          });
          
          // 添加额外的触摸事件处理，防止搜索栏滚动"逃脱"
          $search_bar.on('touchstart.searchbar', function(e) {
            this._touchStartY = e.originalEvent.touches[0].clientY;
          });
          
          $search_bar.on('touchmove.searchbar', function(e) {
            if (!this._touchStartY) {
              this._touchStartY = e.originalEvent.touches[0].clientY;
            }
            
            const touchY = e.originalEvent.touches[0].clientY;
            const scrollTop = this.scrollTop;
            const scrollHeight = this.scrollHeight;
            const clientHeight = this.clientHeight;
            const isScrollingUp = touchY > this._touchStartY;
            const isScrollingDown = touchY < this._touchStartY;
            
            // 在顶部向上滑动或底部向下滑动时阻止默认行为
            if ((isScrollingUp && scrollTop <= 0) || 
                (isScrollingDown && scrollTop + clientHeight >= scrollHeight - 1)) {
              e.preventDefault();
            }
            
            this._touchStartY = touchY;
          });
        } else {
          // 恢复搜索栏默认状态
          $search_bar.css({
            'position': '',
            'top': '',
            'left': '',
            'right': '',
            'z-index': '',
            'overflow-y': '',
            '-webkit-overflow-scrolling': ''
          });

          // 移除所有触摸事件监听
          document.removeEventListener('wheel', preventScroll);
          document.removeEventListener('touchmove', preventScroll);
          document.removeEventListener('touchstart', preventScroll);
          document.removeEventListener('touchend', preventScroll);
          document.removeEventListener('touchcancel', preventScroll);
          
          // 移除额外的触摸事件处理
          $search_bar.off('touchstart.searchbar touchmove.searchbar');

          // 移除 body 的类
          $('body').removeClass('search-active');

          // 隐藏蒙版
          $searchOverlay.css({
            "opacity": 0,
            "visibility": "hidden",
            "z-index": ""
          });

          // search-bar 关闭时, 启用 footer-decor
          $footerDecor.css({
            "display": "block"
          });
        }
      } else {
        // PC端设置
        if (hasActiveClass) {
          $search_bar.css({
            'height': `calc(100vh - ${headerHeight}px)`,
            'overflow-y': 'auto'
          });

          document.addEventListener('wheel', preventScroll, { passive: false });
          document.addEventListener('touchmove', preventScroll, { passive: false });
          document.addEventListener('touchstart', preventScroll, { passive: false });
        } else {
          $search_bar.css({
            'height': '',
            'overflow-y': ''
          });

          document.removeEventListener('wheel', preventScroll);
          document.removeEventListener('touchmove', preventScroll);
          document.removeEventListener('touchstart', preventScroll);
        }
      }
    }

    // 初始化时设置高度
    setSearchBarHeight();
    
    // 添加 search-bar-close 点击事件
    $('.search-bar-close').on('click', function(e) {
      e.stopPropagation(); // 阻止事件冒泡
      $search_bar.removeClass('active');
    });
    
    // 监听search-bar的class变化
    const searchBarObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          setSearchBarHeight();
        }
      });
    });
    
    // 开始观察search-bar的class变化
    searchBarObserver.observe($search_bar[0], {
      attributes: true,
      attributeFilter: ['class'],
    });
    
    // 监听视窗大小变化
    $(window).on('resize', function() {
      setSearchBarHeight();
    });

    // 在搜索表单的作用域内
    if ($search_form.length) {
      var $input = $search_form.children('[name=q]'),
        defaultSearch = $input.data('default-search');

      // 如果有默认搜索词,添加伪placeholder
      if (defaultSearch) {
        $input.after('<div class="default-search-text">' + defaultSearch + '</div>');

        // 当输入框有内容时隐藏默认搜索词
        $input.on('focus', function () {
          const query = $(this).val().trim();
          $clear_input.toggle(!!query);
        });

        // 输入监听
        $input.on(
          'input',
          $.debounce(function() {
            const query = $(this).val().trim();
            const $defaultSearchText = $('.default-search-text');

            // 根据是否有输入内容来显示/隐藏默认搜索词
            if (query) {
              $defaultSearchText.hide();
              $clear_input.show();
            } else {
              $defaultSearchText.show();
              $clear_input.hide();
            }

            // 如果输入内容为空或长度小于2，则清空预测搜索结果
            if (!query || query.length < 2) {
              $predictive_results.removeClass('active');
              currentPage = 1;
              hasMore = true;
              currentQuery = '';
              $predictive_items.empty();
              return;
            }

            if (query !== currentQuery) {
              currentPage = 1;
              hasMore = true;
              currentQuery = query;
              debouncedLoadSearchResults(query); // 使用防抖后的函数
            }
          })
        );
        // 修改清除按钮点击事件
        $clear_input.on('click', function () {
          $input.val('');
          $(this).hide();
          $('.default-search-text').show(); // 显示默认搜索词
          $predictive_results.removeClass('active');
          $predictive_items.empty();
          // 触发 input 事件以确保状态更新
          $input.trigger('input');
        });
        
        // 修改输入框聚焦事件
        $input.on('focus', function () {
          const query = $(this).val().trim();
          // 只在有输入内容时隐藏默认搜索词
          if (query) {
            $('.default-search-text').hide();
          }
          // 只在有输入内容时显示清除按钮
          $clear_input.toggle(!!query);
        });
      }
    }

    // Best Sellers 轮播 (Swiper)
    let swiper;
    function initSwiper() {
      // 获取推荐产品并初始化轮播
      async function initBestSellers() {
        const $wrapper = $('.search-best-sellers-wrapper');
        
        try {
          let products;
          // 检查是否在产品页面
          if (window.location.pathname.includes('/products/')) {
            // 获取当前产品的ID
            const productId = window.meta?.product?.id;
            if (productId) {
              try {
                // 尝试获取推荐产品
                const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`);
                const data = await response.json();
                if (data.products && data.products.length > 0) {
                  // 使用推荐API返回的产品
                  products = data.products;
                }
              } catch (error) {
                console.error('Error fetching recommendations:', error);
              }
            }
          }
          
          // 如果不在产品页面或获取推荐失败，使用metafield中的产品
          if (!products) {
            products = window.search_variable?.best_sellers || [];
          }

          if (products.length === 0) {
            console.log('No any products');
            // 如果没有任何产品，隐藏整个板块
            $('.search-best-sellers').hide();
            return;
          }

          // 生成产品HTML
          const productsHtml = products.map(product => {
            const firstVariant = product.variants[0];
            // 处理产品URL
            const productUrl = product.url || `/products/${product.handle}`;
            // 处理产品图片
            const productImage = product.featured_image || product.images?.[0] || product.image?.src;
            const price = formatPrice(firstVariant.price);
            const comparePrice = firstVariant.compare_at_price ? formatPrice(firstVariant.compare_at_price) : '';
            
            return `
              <a href="${productUrl}" class="search-best-sellers-item swiper-slide">
                <div class="search-product-image">
                  <img src="${productImage}" alt="${product.title}">
                </div>
                <div class="search-product-info">
                  <h3 class="search-product-title">${product.title}</h3>
                  <div style="display: flex;" data-bv-show="inline_rating" data-bv-product-id="${product.id}" data-bv-redirect-url="${product.url}" data-bv-seo="false"> </div>
                  <div class="search-product-price">
                    <strong class="price">${price}</strong>
                    ${comparePrice ? `<del class="compare-at-price text-secondary">${comparePrice}</del>` : ''}
                  </div>
                  <button class="button button-global search-bar-add-cart-btn" variant-id="${firstVariant.id}">
                    <span class="search-bar-add">+ </span>
                    <span>ADD TO CART</span>
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 0.666626H3.0825L3.48352 2.72723H12.5L10.4949 7.87875H4.48606L4.68657 8.90905H10.1244V9.93935H3.79906L2.195 1.69693H0.5V0.666626ZM4.28555 6.84844H9.75384L10.9569 3.75753H3.68403L4.28555 6.84844Z" fill="#6A51B7"/>
                      <path d="M4.24282 11.2272C4.24282 10.8005 4.6019 10.4545 5.04485 10.4545C5.4878 10.4545 5.84688 10.8005 5.84688 11.2272C5.84688 11.654 5.4878 12 5.04485 12C4.6019 12 4.24282 11.654 4.24282 11.2272Z" fill="#6A51B7"/>
                      <path d="M7.98563 11.2272C7.98563 10.8005 8.34471 10.4545 8.78766 10.4545C9.23061 10.4545 9.58969 10.8005 9.58969 11.2272C9.58969 11.654 9.23061 12 8.78766 12C8.34471 12 7.98563 11.654 7.98563 11.2272Z" fill="#6A51B7"/>
                    </svg>  
                  </button>
                </div>
              </a>
            `;
          }).join('');

          // 更新DOM
          $wrapper.html(productsHtml);

          // 只有在屏幕大于1366px时初始化Swiper
          if (window.innerWidth > 1366) {
            if (swiper) {
              swiper.destroy(true, true);
            }
            
            swiper = new Swiper(".search-best-sellers-container", {
              slidesPerView: 4,
              spaceBetween: 30,
              touchEventsTarget: 'container',
              preventClicks: false,
              preventClicksPropagation: false,
              slideToClickedSlide: false,
              touchRatio: 1,
              touchStartPreventDefault: false,
              navigation: {
                nextEl: '.best-sellers-swiper-button-next',
                prevEl: '.best-sellers-swiper-button-prev',
              },
              threshold: 5,
              touchMoveStopPropagation: true,
              on: {
                touchStart: function(swiper, event) {
                  swiper.clickTimeout = undefined;
                  swiper.dragStarted = false;
                },
                touchMove: function(swiper, event) {
                  swiper.dragStarted = true;
                },
                touchEnd: function(swiper, event) {
                  if (swiper.dragStarted) {
                    event.preventDefault();
                    const links = swiper.el.querySelectorAll('a');
                    links.forEach(link => {
                      link.addEventListener('click', e => e.preventDefault(), { once: true });
                    });
                  }
                }
              }
            });
          }
        } catch (error) {
          console.error('Error:', error);
          // 如果出现错误，尝试使用metafield中的产品
          if (window.search_variable?.best_sellers) {
            const products = window.search_variable.best_sellers;
            // 重新运行产品展示逻辑
            initBestSellers();
          } else {
            // 如果都没有产品，隐藏整个板块
            $('.search-best-sellers').hide();
          }
        }
      }

      // 初始化Best Sellers
      initBestSellers();
    }
    initSwiper();
    // 监听窗口大小变化
    window.addEventListener('resize', function() {
      initSwiper();
    });

    // 在初始化时添加确认删除历史搜索记录弹窗模板
    $('body').append(`
      <div class="confirm-dialog-overlay"></div>
      <div class="confirm-dialog">
        <div class="confirm-dialog-content">
          <p>Are You Sure To Delete All Search History?</p>
          <div class="confirm-dialog-buttons">
            <button class="confirm-dialog-cancel">No</button>
            <button class="confirm-dialog-confirm">Yes</button>
          </div>
        </div>
      </div>
    `);

    // 修改确认弹窗相关函数
    const showConfirmDialog = function(onConfirm) {
      const $overlay = $('.confirm-dialog-overlay');
      const $dialog = $('.confirm-dialog');
      const $confirmBtn = $('.confirm-dialog-confirm');
      const $cancelBtn = $('.confirm-dialog-cancel');
      
      // 显示弹窗前先解绑所有事件
      $confirmBtn.add($cancelBtn).add($overlay).off('click');
      
      // 显示弹窗
      $overlay.add($dialog).addClass('active');

      const hideConfirmDialog = function() {
        $overlay.add($dialog).removeClass('active');
      };

      // 处理确认操作
      const handleConfirm = function(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        onConfirm();
        hideConfirmDialog();
        // 显示成功提示
        $.showFormReminder({
          action: 'delete-history',
          status: 'success',
          message: 'Success'
        });
      };

      // 处理取消操作
      const handleCancel = function(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        hideConfirmDialog();
      };

      // 绑定事件处理器
      $confirmBtn.on('click touchend', handleConfirm);
      $cancelBtn.on('click touchend', handleCancel);
      $overlay.on('click touchend', handleCancel);

      // 防止事件冒泡
      $dialog.on('click touchend', function(e) {
        e.stopPropagation();
      });
    };

    // 修改清空历史记录的点击事件
    $search_history.on('click touchend', '.clear-all-history', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showConfirmDialog(function() {
        searchHistory.clearAll();
      });
    });

    // 后退按钮点击事件
    $('.search-back-button').on('click', function () {
      $search_bar.removeClass('active');
    });

    // 在初始化时添加确认删除历史搜索记录弹窗后添加
    $(document).on('keydown', function(e) {
      // Enter 键 (keyCode 13) 事件
      if (e.keyCode === 13) {
        // 第一优先级：确认删除历史搜索记录弹窗
        if ($('.confirm-dialog').hasClass('active')) {
          e.preventDefault();
          // 触发确认按钮的点击事件
          $('.confirm-dialog-confirm').trigger('click');
        }
        // 第二优先级：search-bar 激活状态
        else if ($('.search-bar').hasClass('active')) {
          e.preventDefault();
          // 触发表单提交
          $search_form.trigger('submit');
        }
      }
      
      // ESC 键 (keyCode 27) 事件
      if (e.keyCode === 27) {
        // 第一优先级：确认删除历史搜索记录弹窗
        if ($('.confirm-dialog').hasClass('active')) {
          e.preventDefault();
          // 触发取消按钮的点击事件
          $('.confirm-dialog-cancel').trigger('click');
        }
        // 第二优先级：关闭预测搜索容器
        else if ($('.predictive-search-results').hasClass('active')) {
          e.preventDefault();
          $('.predictive-search-results').removeClass('active');
        }
        // 第三优先级：关闭search-bar
        else if ($('.search-bar').hasClass('active')) {
          e.preventDefault();
          $('.search-bar').removeClass('active');
        }
      }
    });
  }

  // 点击search-bar其他地方关闭预测搜索结果
  $(document).on('click', function (e) {
    if (!$(e.target).closest($search_bar).length) {
      $predictive_results.removeClass('active');
    }
  });

  // 防止搜索结果区域的点击事件冒泡
  $predictive_results.on('click', function (e) {
    e.stopPropagation();
  });

  // 添加搜索栏中 add to cart 按钮的点击事件处理
  $(".search-bar").on("click", ".search-bar-add-cart-btn", function(eve) {
    // 阻止事件冒泡和默认行为
    eve.preventDefault();
    eve.stopPropagation();
    
    var formData = {
      'items': [{
        'id': Number($(this).attr('variant-id')),
        'quantity': 1
      }]
    };

    if ('fetch' in window) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        $.showFormReminder({
          action: 'add-cart',
          status: response.status === 304 ? 'cache' : response.ok ? 'success' : 'error'
        });
        if (response.status === 304) {
          return null;
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Response failure');
        }
      })
      .then(data => {
        if (data) {
          // 可以在这里添加成功后的处理逻辑
        }
      })
      .catch(error => console.error(error));
    } else {
      $.ajax({
        type: 'POST',
        url: window.Shopify.routes.root + 'cart/add.js',
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        complete: function(xhr, status) {
          $.showFormReminder({
            action: 'add-cart',
            status: status
          });
        }
      });
    }
  });
}));